import { CommonModule, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import {
  CourseContentActions,
  CourseSubSection,
  CoursesContent,
  MyClassService,
  SharedModule,
  selectCourseContent,
} from '@shared';
import {
  AssignmentSubmissionPayload,
  MyClassAssignmentAnswer,
  VideoLectureProgress,
  selectActiveSubsection,
  selectActiveSubsectionLists,
  selectCoursesCertificate,
} from '@shared/store/learning-lab';
import * as _ from 'lodash';
import { Observable, Subscription, combineLatest, filter, firstValueFrom, take } from 'rxjs';
import {
  CourseQuizAnswer,
  CourseQuizAnswerPayload,
  LocalStorage,
  Logger,
  RouterStoreService,
  ToastService,
} from 'thkee-common';
const log = new Logger('LearninglabActivityComponent');

@UntilDestroy()
@Component({
  selector: 'app-learninglab-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
  standalone: true,
  imports: [CommonModule, NgTemplateOutlet, NgIf, RouterLink, SharedModule],
})
export class LearninglabActivityComponent implements OnInit, OnDestroy {
  @Output() event = new EventEmitter<{ action: string; data: any }>();

  // TODO: Update this
  currentSection: string = '';
  activeSubsection: string = '';
  params: any;
  // currentActivity?: SubsectionDetailV2;
  currentActivity?: any;

  sectionsData: any[] = []; // TODO: Fix proper model here
  sectionData: any = {}; // TODO: fix proper model here
  prev!: string[];
  next!: string[];
  prevData!: any[];
  nextData!: any[];

  // courseDetail$!: Observable<CourseDetailV2>;
  courseDetail$!: Observable<CoursesContent>;

  completedActivity: boolean[] = [];
  activityModels: any[] = [];

  getAssignmentAnswers$!: Observable<any>;
  isLoading: boolean = true;
  private markedAsReadSubscription = new Subscription();

  subsections$ = this.store.select(selectActiveSubsectionLists);

  isPreview!: string;
  isFrom!: string;

  constructor(
    private routerStore: RouterStoreService,
    private router: Router,
    private store: Store,
    private myClassService: MyClassService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.courseDetail$ = this.store
      .select(selectCourseContent)
      .pipe(filter((courseDetail) => (courseDetail.results?.length ?? 0) > 0));

    combineLatest([this.routerStore.getParams(), this.courseDetail$])
      .pipe(untilDestroyed(this))
      .subscribe(([params, courseDetail]) => {
        this.sectionsData = courseDetail.results ?? [];
        this.sectionData = _.groupBy(
          courseDetail.results?.flatMap((section) => section.subsections),
          (subsection) => subsection
        );

        this.params = params;
        this.currentSection = params['section'];
        this.activeSubsection = params['subsection'];
        if (!params['section']) {
          // Set Init Section
          if (this.sectionsData) {
            this.currentSection = this.sectionsData[0].chain_id;
          }
        }

        const sectionData: any = Object.values(this.sectionData)[0] || [];
        const currentData = sectionData.find((data: { chain_id: string }) => data.chain_id === this.activeSubsection);
        // Select first sub section if not selected
        if (!params['subsection'] && this.currentSection) {
          if (currentData) {
            this.activeSubsection = currentData.chain_id;
          }
        }

        this.currentActivity = currentData;
        if (!this.currentActivity) {
          this.isLoading = true;
          setTimeout(() => {
            this.isLoading = false;
          }, 3000);
        }

        if (this.currentActivity) {
          this.isLoading = false;
          if (this.currentActivity?.type == 'assignment') {
            this.initAssignment(this.currentActivity?.assignment);
          }
          if (this.currentActivity?.type == 'quiz') {
            this.initQuiz(this.currentActivity?.quiz);
          }
        }

        this.setPrevNext();
      });

    this.isPreview = this.activatedRoute.snapshot.queryParams['preview'];
    this.isFrom = this.activatedRoute.snapshot.queryParams['from'];
  }

  ngOnDestroy(): void {
    this.markedAsReadSubscription.unsubscribe();
  }

  videoProgress!: VideoLectureProgress;

  activityHandler(event: VideoLectureProgress) {
    this.event.emit(event);
    if (event.action == 'prev') {
      this.prevActivity();
    }
    if (this.next.length > 0) {
      if (['next'].includes(event.action)) {
        this.nextActivity();
      }
    }
    if (this.next.length > -1) {
      if (event.action === 'progress' && this.next.length > 0) {
        this.videoProgress = event;
        this.markedAsReadAutomatically();
      }
      if (event.action === 'progress' && this.next.length === 0) {
        this.videoProgress = event;
        const progress = this.calculateVideoProgressPercentage(event.data.currentTime, event.data.currentDuration);
        if (progress === 100) {
          this.markedAsReadAutomatically();
        }
      }
    }
    // Assignment
    if (['assignment_start', 'assignment_submit'].includes(event.action)) {
      this.assignmentHandler(event);
    }
    if (['quiz_start', 'quiz_completed'].includes(event.action)) {
      this.quizHandler(event);
    }
    if (['ended'].includes(event.action)) {
      // this.nextActivity();
    }

    if (this.next.length === 0 && event.action === 'ended') {
      this.markedAsRead(true);
    }

    if (event.action === 'pause' && event.data.currentTime !== event.data.currentDuration) {
      this.saveVideoPosition(false);
    }
  }

  prevActivity() {
    this.setPrevNext();
    // this.router.navigate([
    //   'learning-lab',
    //   this.params.courseId,
    //   this.params.tab,
    //   ...this.prev,
    //   this.params.overviewcode,
    // ]);
    this.updateRoute(this.prev);
    setTimeout(() => {
      this.selectActivity(this.params['section'], this.params['subsection']);
    });
  }

  nextActivity() {
    if (this.videoProgress && this.videoProgress.data.currentTime !== this.videoProgress.data.currentDuration) {
      this.saveVideoPosition(false);
    }
    this.setPrevNext();
    // this.router.navigate([
    //   'learning-lab',
    //   this.params.courseId,
    //   this.params.tab,
    //   ...this.next,
    //   this.params.overviewcode,
    // ]);
    this.updateRoute(this.next);
    this.store.dispatch(CourseContentActions.nextActivity());
    setTimeout(() => {
      this.selectActivity(this.params['section'], this.params['subsection']);
      this.markedAsRead();
    });
  }

  updateRoute(nextPrev: string[] = []) {
    if (this.isPreview) {
      this.router.navigate(
        ['learning-lab', this.params.courseId, this.params.tab, ...nextPrev, this.params.overviewcode],
        {
          queryParams: { preview: this.isPreview, from: this.isFrom },
          replaceUrl: true,
        }
      );
    } else {
      this.router.navigate([
        'learning-lab',
        this.params.courseId,
        this.params.tab,
        ...nextPrev,
        this.params.overviewcode,
      ]);
    }
  }

  saveVideoPosition(autoSave = false) {
    if (!this.isPreview) {
      let duration: string | null;
      if (autoSave) {
        LocalStorage.removeStorageItem('current_video_position');
        duration = '0';
      } else {
        duration = LocalStorage.getText('current_video_position');
      }
      firstValueFrom(this.store.select(selectActiveSubsection)).then((subs) => {
        if (this.params['overviewcode'] && subs?.type === 'lecture' && subs.lecture?.type === 'video' && duration) {
          this.myClassService
            .markedAsRead({ subsection: subs?.id ?? '', watched_duration: duration }, this.params['overviewcode'])
            .pipe(take(1), untilDestroyed(this))
            .subscribe({
              next: (res) => {},
              error: ({ error }) => {
                this.toastService.error({
                  message: error.error,
                });
              },
            });
        }
      });
    }
  }

  selectActivity(sectionId: string, subsectionId: string) {
    this.store.dispatch(
      CourseContentActions.selectActivity({
        sectionId,
        subsectionId,
      })
    );
  }

  setPrevNext() {
    const [previousItem, nextItem, nextSectionId, previousSectionId, nextData, prevData] =
      this.findPreviousAndNextItems(this.sectionsData ?? [], this.params['subsection']);
    this.prev = previousItem ? [previousSectionId, previousItem] : [];
    this.next = nextItem ? [nextSectionId, nextItem] : [];
    this.nextData = nextData;
    this.prevData = prevData;
  }

  markedAsRead(lastSection = false) {
    const subsections: any = Object.values(this.sectionData)[0];
    const index: number = subsections.findIndex((d: CourseSubSection) => d.chain_id === this.params['subsection']);
    let section: CourseSubSection;
    if (lastSection) {
      section = subsections[index];
    } else {
      section = subsections[index - 1];
    }
    if (section?.type) {
      if (section.type === 'quiz' || section.type === 'assignment' || section?.lecture?.type === 'article') {
        this.marked(section, index);
      }
      if (section.type === 'lecture' && section?.lecture?.type === 'video') {
        const progress = this.calculateVideoProgressPercentage(
          this.videoProgress.data.currentTime,
          this.videoProgress.data.currentDuration
        );
        if (progress > 80) {
          this.marked(section, index, this.videoProgress.data.currentTime);
        }
      }
    } else {
      // this.currentActivity = { type: 'completed' };
    }
  }

  isMarked = false;
  markedAsReadAutomatically() {
    const subsections: any = Object.values(this.sectionData)[0];
    const index: number = subsections.findIndex((d: CourseSubSection) => d.chain_id === this.params['subsection']);
    let section: CourseSubSection;
    section = subsections[index];

    if (section?.type && section.type === 'lecture' && section?.lecture?.type === 'video') {
      const progress = this.calculateVideoProgressPercentage(
        this.videoProgress.data.currentTime,
        this.videoProgress.data.currentDuration
      );
      if (progress < 95) {
        this.isMarked = false;
      }
      if (progress > 95 && !this.isMarked) {
        this.marked(section, index, 0);
        this.saveVideoPosition(true);
        this.isMarked = true;
      }
    }
  }

  // Calculate video progress as percentage
  calculateVideoProgressPercentage(currentTime: number, currentDuration: number): number {
    if (currentDuration === 0) {
      return 0;
    }
    const progressPercentage = (currentTime / currentDuration) * 100;
    return Math.min(Math.max(progressPercentage, 0), 100);
  }

  marked(data: CourseSubSection, index: number, duration: number = 0) {
    if (!data.is_completed) {
      if (!this.isPreview) {
        const body = {
          position: index,
          subsection: data.id,
          is_completed: true,
          watched_duration: Math.round(duration),
        };
        this.markedAsReadSubscription.add(
          this.myClassService
            .markedAsRead(body, this.params['overviewcode'])
            .pipe(take(1), untilDestroyed(this))
            .subscribe((res) => {
              this.store.dispatch(CourseContentActions.markedAsReadSuccess(res));
              this.store.dispatch(CourseContentActions.loadCourseCertificate({ product_id: this.params['courseId'] }));
            })
        );

        setTimeout(() => {
          this.store
            .select(selectCoursesCertificate)
            .pipe(take(1), untilDestroyed(this))
            .subscribe((data) => {
              if (data.completed_status === 'completed' && this.next.length === 0) {
                this.currentActivity = { type: 'completed' };
              }
            });
        }, 3000);
      }
    }
  }

  findPreviousAndNextItems(data: any[], selectedItemId: string): any[] {
    let previousItem: string | null = null;
    let nextItem: string | null = null;
    let previousSectionId: string | null = null;
    let nextSectionId: string | null = null;
    let nextData: string | null = null;
    let prevData: string | null = null;

    for (let i = 0; i < data.length; i++) {
      const section = data[i];

      for (let j = 0; j < section.subsections.length; j++) {
        const subsection = section.subsections[j];

        if (subsection.chain_id === selectedItemId) {
          if (j > 0) {
            previousItem = section.subsections[j - 1].chain_id;
            prevData = section.subsections[j - 1][section.subsections[j - 1].type];
            previousSectionId = section.chain_id;
          } else if (i > 0 && data[i - 1].subsections.length > 0) {
            // If no previous item in the current subsection, check the previous section's last subsection
            const prevSubsections = data[i - 1].subsections;
            previousItem = prevSubsections[prevSubsections.length - 1].chain_id;
            prevData = prevSubsections[prevSubsections.length - 1][prevSubsections[prevSubsections.length - 1].type];
            previousSectionId = data[i - 1].chain_id;
          }

          if (j < section.subsections.length - 1) {
            nextItem = section.subsections[j + 1].chain_id;
            nextData = section.subsections[j + 1][section.subsections[j + 1].type];
            nextSectionId = section.chain_id;
          } else if (i < data.length - 1 && data[i + 1].subsections.length > 0) {
            // If no next item in the current subsection, check the next section's first subsection
            nextItem = data[i + 1].subsections[0].chain_id;
            nextData = data[i + 1].subsections[0][data[i + 1].subsections[0].type];
            nextSectionId = data[i + 1].chain_id;
          }

          return [previousItem, nextItem, nextSectionId, previousSectionId, nextData, prevData];
        }
      }
    }

    return [previousItem, nextItem, nextSectionId, previousSectionId, nextData, prevData];
  }

  // Assignment Init
  initAssignment(assignment: any) {
    if (assignment.id && assignment.questions) {
      // Add Dispatch Q Here
      // this.store.dispatch(
      //   LearningLabActions.getAssignmentAnswers({ courseId: this.params.courseId, assignId: assignment.id })
      // );
    }
  }

  // Assignement Event Handler
  assignmentHandler(event: any) {
    // if (event.action == 'assignment_start') {}
    if (event.action == 'assignment_submit') {
      if (this.next.length === 0) {
        this.markedAsRead(true);
      }
      const assignment_id = (event.data as any)?.data?.assignment?.id;
      if (assignment_id) {
        const answers = (event.data as any)?.model;
        if (answers) {
          const formatedAnswers: MyClassAssignmentAnswer[] = Object.keys(answers).map((question_id, index) => ({
            question_id,
            answer: answers[question_id],
          }));
          this.assignmentSubmit(assignment_id, formatedAnswers);
        }
      }
    }
  }

  // Assignment Submit
  assignmentSubmit(assignment_id: string, answers: MyClassAssignmentAnswer[]) {
    const formattedPayload: AssignmentSubmissionPayload = {
      content: answers,
    };
    // console.log('answers--', { courseId: this.params.courseId, assignId: assignment_id, payload: answers });
    this.store.dispatch(
      CourseContentActions.submitAssignment({
        courseId: this.params.courseId,
        assignId: assignment_id,
        payload: formattedPayload,
      })
    );
    this.nextActivity();
  }

  // Quiz Init
  initQuiz(quiz: any) {
    if (quiz.id && quiz.questions) {
      // console.log('initQuiz--', quiz);
      // Add Dispatch Q Here
      // this.store.dispatch(LearningLabActions.getQuizAnswers({ courseId: this.params.courseId, quizId: quiz.id }));
    }
  }

  // Submit / Complete Quiz
  quizHandler(event: any) {
    if (event.action == 'quiz_completed') {
      if (this.next.length === 0) {
        this.markedAsRead(true);
      }
      const quiz_id = (event.data as any)?.data?.quiz?.id;
      if (quiz_id) {
        const answers = (event.data as any)?.model;
        if (answers) {
          const formatedAnswers: CourseQuizAnswer[] = Object.keys(answers).map((question, index) => ({
            question_id: question,
            answer_id: answers[question],
          }));
          const formatedPayload: CourseQuizAnswerPayload = {
            content: formatedAnswers,
          };
          this.store.dispatch(
            CourseContentActions.submitQuiz({
              courseId: this.params.courseId,
              quizId: quiz_id,
              payload: formatedPayload,
            })
          );
          // this.nextActivity();
        }
      }
    }
  }
}
